import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { EarnsDetail, getEarnsDetail } from 'api/v1/earns/detail'
import {
  fetchEarnsDetailAction,
  fetchEarnsLuckyListAction,
  fetchEarnsTodayTradeAction,
} from './actions'
import { Address } from 'types'
import { MomentumLevel, MomentumMultiplier } from './types'

export interface EarnsMomentum {
  level: MomentumLevel
  nextLevel: MomentumLevel
  multiplier: number
  day7Volume: number
  nextVolume: number
  useDate: string // 2024-03-21 00:00 To 23:59
  progress: number // 0 ~ 1 (percentage), 1 means 100%, rocket progress
}
export interface EarnsState {
  detail: EarnsDetail | undefined
  today: number // Today trade amount
  lucky: Address[] // Lucky list
  momentum: EarnsMomentum
  countdown: number
}

const defaultMomentum = {
  level: MomentumLevel.Level0,
  nextLevel: MomentumLevel.Level1,
  multiplier: MomentumMultiplier[MomentumLevel.Level0],
  day7Volume: 0,
  nextVolume: 0,
  useDate: '',
  progress: 0,
}

const initialState: EarnsState = {
  detail: undefined,
  today: 0,
  lucky: [],
  momentum: defaultMomentum,
  countdown: 0,
}

const earnsSlice = createSlice({
  name: 'earns',
  initialState,
  reducers: {
    updateEarnsMomentum(state, { payload }: PayloadAction<EarnsMomentum>) {
      state.momentum = payload
    },
    updateEarnsCountdown(state, { payload }: PayloadAction<number>) {
      state.countdown = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEarnsDetailAction.fulfilled, (state, { payload }) => {
        state.detail = payload
      })
      .addCase(fetchEarnsTodayTradeAction.fulfilled, (state, { payload }) => {
        state.today = payload
      })
      .addCase(fetchEarnsLuckyListAction.fulfilled, (state, { payload }) => {
        state.lucky = payload
      })
  },
})

export const { updateEarnsMomentum, updateEarnsCountdown } = earnsSlice.actions

export default earnsSlice.reducer
